import React, { useContext, useState } from 'react';
import {
	Analysis,
	CardWrapper,
	ContentWrapper,
	ExploreButton,
	Heading,
	IconWrapper,
	RiskWrapper,
	SubWrapper,
	Wrapper,
} from './Cards.styles';
import { ApIcon, ApLoaderDefault } from '@alixpartners/ui-components';
import { InsightsType } from 'CategoryManagement/utils';
import { CategorySpendBenchmarkContext } from 'contexts/CategorySpendBenchmark';
import { cardColorDefault, iconColor } from './utils';
import ExploreModal from 'CategoryManagement/Explore/ExploreModal';
import SpendWithinBenchmarkExplore from 'CategoryManagement/Explore/DetailedAnalysis/SpendWithinBenchmarkExplore';

const CategorySpendWithinBenchmark = ({ name }) => {
	const { isFetching: isLoading, analysisWithinSpend, gridData } = useContext(
		CategorySpendBenchmarkContext
	);
	const [isExplore, setIsExplore] = useState(false);

	return (
		<>
			<Wrapper>
				<SubWrapper>
					<RiskWrapper tileColor={cardColorDefault} />
					<CardWrapper>
						<IconWrapper iconColor={iconColor}>
							<div>
								<ApIcon
									material={true}
									iconName={InsightsType[1].iconName}
									iconSize={20}
								/>
							</div>
							<div>
								{!isLoading &&
									gridData.rowData.length > 0 && (
										<ExploreButton
											title="Explore"
											className="explore"
											onClick={() => setIsExplore(true)}
										>
											<ApIcon
												title="Explore"
												material={true}
												iconName="find_in_page"
											/>
										</ExploreButton>
									)}
							</div>
						</IconWrapper>
						{isLoading ? (
							<ApLoaderDefault />
						) : (
							<ContentWrapper>
								<Heading>{name}</Heading>
								<Analysis>{analysisWithinSpend}</Analysis>
							</ContentWrapper>
						)}
					</CardWrapper>
				</SubWrapper>
			</Wrapper>
			{isExplore && (
				<ExploreModal title={name} onClose={setIsExplore}>
					<SpendWithinBenchmarkExplore />
				</ExploreModal>
			)}
		</>
	);
};

export default CategorySpendWithinBenchmark;
